import { CONTROL_BORDER, STRONG_BORDER_COLOR } from '../highContrastSx';

const FIELD_SURFACE_SX = Object.freeze({
    bgcolor: 'grey.50',
    border: CONTROL_BORDER,
    borderColor: STRONG_BORDER_COLOR,
    borderRadius: 2,
});

export default FIELD_SURFACE_SX;
